import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { SettingsModule } from '@/store/modules/settings';
import ThemePicker from '@/components/ThemePicker/index.vue';
let default_1 = class extends Vue {
  get fixedHeader() {
    return SettingsModule.fixedHeader;
  }
  set fixedHeader(value) {
    SettingsModule.ChangeSetting({
      key: 'fixedHeader',
      value
    });
  }
  get showTagsView() {
    return SettingsModule.showTagsView;
  }
  set showTagsView(value) {
    SettingsModule.ChangeSetting({
      key: 'showTagsView',
      value
    });
  }
  get showSidebarLogo() {
    return SettingsModule.showSidebarLogo;
  }
  set showSidebarLogo(value) {
    SettingsModule.ChangeSetting({
      key: 'showSidebarLogo',
      value
    });
  }
  get showSidebarTitle() {
    return SettingsModule.title;
  }
  set showSidebarTitle(value) {
    SettingsModule.ChangeSetting({
      key: 'title',
      value
    });
  }
  get sidebarTextTheme() {
    return SettingsModule.sidebarTextTheme;
  }
  set sidebarTextTheme(value) {
    SettingsModule.ChangeSetting({
      key: 'sidebarTextTheme',
      value
    });
  }
  themeChange(value) {
    SettingsModule.ChangeSetting({
      key: 'theme',
      value
    });
  }
};
default_1 = __decorate([Component({
  name: 'Settings',
  components: {
    ThemePicker
  }
})], default_1);
export default default_1;